import { useI18n } from "vue-i18n";

export function useFormattedSeconds() {
    const { t } = useI18n();

    const convertSeconds = function (seconds: number) {
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        const result = [];

        if (days > 0) {
            result.push(`${days} ${t("workflows.days", days)}`);
        }

        const remainingHours = hours % 24;
        if (remainingHours > 0) {
            result.push(
                `${remainingHours} ${t("workflows.hours", remainingHours)}`,
            );
        }

        const remainingMinutes = minutes % 60;
        if (remainingMinutes > 0) {
            result.push(
                `${remainingMinutes} ${t("workflows.minutes", remainingMinutes)}`,
            );
        }

        const remainingSeconds = seconds % 60;
        if (remainingSeconds > 0) {
            result.push(
                `${remainingSeconds} ${t("workflows.seconds", remainingSeconds)}`,
            );
        }

        return result.join(", ");
    };

    return {
        convertSeconds,
    };
}
